/**
 * Inventario (INV-01, INV-02): el stock de cada producto y la libreta de todo lo
 * que lo movio.
 *
 * Reemplaza la libreta de papel del negocio, y conserva lo que tenia de bueno:
 * el stock no se "edita", se anota que paso —llego mercaderia, se vendio por
 * fuera, se conto— y el numero sale de ahi. Las ventas del sitio se anotan
 * solas al aprobarse el pago.
 *
 * **Dos pestanas (22-09-2026)** en vez de dos tablas apiladas: antes habia que
 * recorrer el catalogo entero para llegar a la libreta. Cada una tiene su URL y
 * sus filtros (`utilidades/filtros-inventario.ts`): Stock (`VistaStock.tsx`)
 * con contadores que filtran, y Movimientos (`VistaMovimientos.tsx`).
 */
import { useSearchParams } from 'react-router-dom';

import { BarraAdmin } from '../../componentes/administracion/BarraAdmin';
import { PestanasInventario } from '../../componentes/administracion/PestanasInventario';
import { VistaMovimientos } from '../../componentes/administracion/VistaMovimientos';
import { VistaStock } from '../../componentes/administracion/VistaStock';
import { Seo } from '../../seo/Seo';
import { leerVista } from '../../utilidades/filtros-inventario';
import { rutas } from '../../utilidades/rutas';

export function Inventario() {
  const [parametros] = useSearchParams();
  const vista = leerVista(parametros);

  return (
    <>
      <Seo
        titulo="Inventario"
        descripcion="Stock de cada producto y movimientos de inventario."
        ruta={rutas.administracion.inventario()}
        sinIndexar
      />

      <BarraAdmin
        titulo="Inventario"
        bajada={
          vista === 'stock'
            ? 'El stock no se edita: se anota lo que pasó, y el número sale de ahí.'
            : 'Cada cambio de stock, con su motivo.'
        }
        acciones={<PestanasInventario vista={vista} />}
      />

      <div className="admin-cuerpo">
        {vista === 'stock' ? <VistaStock /> : <VistaMovimientos />}
      </div>
    </>
  );
}
